import React from 'react'
import { FaCheck, FaTimes } from 'react-icons/fa'

const BooleanIcon = props => (props.value === true ? <FaCheck color="green" /> : <FaTimes color="red" />)

export default BooleanIcon
